// Default language of an Elakay account (User.language = { code, name, nativeName }).
//
// Mirror of the backend's canonical table (server_elakay/elakay_constants/
// userLanguages.js), which is what actually builds the stored object: the
// frontend only ever sends the code. Same five codes as LanguageSelector's
// SUPPORTED_LANGUAGE_CODES (Email Marketing / Agent profile).
import { SUPPORTED_LANGUAGE_CODES } from "./LanguageSelector";

export const SUPPORTED_USER_LANGUAGES = Object.freeze([
  Object.freeze({ code: "en", name: "English", nativeName: "English" }),
  Object.freeze({ code: "es", name: "Spanish", nativeName: "Español" }),
  Object.freeze({ code: "fr", name: "French", nativeName: "Français" }),
  Object.freeze({ code: "ht", name: "Haitian Creole", nativeName: "Kreyòl ayisyen" }),
  Object.freeze({ code: "pt", name: "Portuguese", nativeName: "Português" }),
].filter((language) => SUPPORTED_LANGUAGE_CODES.includes(language.code)));

// "fr" | { code: "fr", ... } -> "fr"; anything unsupported/missing -> "".
export const resolveUserLanguageCode = (value) => {
  const raw = value && typeof value === "object" ? value.code : value;
  const code = typeof raw === "string" ? raw.trim().toLowerCase() : "";
  return SUPPORTED_USER_LANGUAGES.some((language) => language.code === code) ? code : "";
};

export const findUserLanguage = (code) =>
  SUPPORTED_USER_LANGUAGES.find((language) => language.code === resolveUserLanguageCode(code)) || null;
